import React, {useState, useEffect, useCallback} from "react";
import {Col, FormGroup, Input, ModalFooter, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {getUserModalData, getUserProfile} from "../../redux/Selectors/users.selector";
import Button from "../Button";

import {
  sendAdduserModalData,
  sendEditUserModalData,
  updateAdduserModal,
  updateAdduserModalData,
} from "../../redux/Actions/users.action";
import "./_toggle.scss";
import {isEmpty} from "lodash";
import {toast} from "react-toastify";
import {useFetchUsers} from "../../views/Users/usersTable/useUserTableData";
import ToggleCreator from "./components/ToggleCreator";

const AddUserForm = ({onClose, formType}) => {
  const dispatch = useDispatch();
  const {refetch} = useFetchUsers();
  const [submitted, setSubmitted] = useState(false);
  const [checkPassword, setCheckPassword] = useState(false);
  const update_user_data = useSelector(getUserModalData);
  const userProfile = useSelector(getUserProfile);
  const {
    first_name = "",
    last_name = "",
    email = "",
    username = "",
    password = "",
    confirm_password = "",
    is_superuser = false,
    is_staff = false,
    is_active = true,
  } = update_user_data;
  const onChangeHandler = (e) => {
    let updateObj = {...update_user_data};
    updateObj = Object.assign({}, updateObj, {[e.target.name]: e.target.value});
    if (e.target.name === "confirm_password") {
      setCheckPassword(false);
    }
    dispatch(updateAdduserModalData(updateObj));
  };
  const handleToggle = (name, value) => {
    let updateObj = {...update_user_data};
    updateObj = Object.assign({}, updateObj, {[name]: value});
    dispatch(updateAdduserModalData(updateObj));
  };
  const validatePassword = () => {
    if (password === confirm_password) {
      return true;
    } else {
      setCheckPassword(true);
      toast.error("Passwords do not match");
      return false;
    }
  };
  const saveCallback = () => {
    onClose();
    refetch();
  };

  const addUserData = () => {
    if (!isEmpty(username) && !isEmpty(email) && !isEmpty(password)) {
      if (validatePassword()) {
        dispatch(sendAdduserModalData(update_user_data, saveCallback));
      }
    } else {
      toast.error("Please check required fields");
    }
  };

  const editUserData = () => {
    if (!isEmpty(email)) {
      if (validatePassword()) {
        dispatch(sendEditUserModalData(update_user_data, saveCallback));
      }
    } else {
      toast.error("Please check required fields");
    }
  };
  const onFormSubmit = () => {
    setSubmitted(true);
    if (update_user_data.id) {
      editUserData();
    } else {
      addUserData();
    }
  };

  const onFormCancel = useCallback(() => {
    dispatch(updateAdduserModal(false));
    dispatch(updateAdduserModalData({}));
    onClose();
  }, [dispatch, onClose]);

  useEffect(() => {
    window.addEventListener("beforeunload", onFormCancel);
    return () => {
      window.removeEventListener("beforeunload", onFormCancel);
    };
  }, [onFormCancel]);

  return (
    <>
      <div>
        <div className="pl-lg-4">
          <Row>
            {formType !== "Change Password" && (
              <>
                <Col lg="12">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="first_name">
                      First Name
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="first_name"
                      placeholder="Enter First Name"
                      type="text"
                      name="first_name"
                      data-cy="first_name"
                      value={first_name}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg="12">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="last_name">
                      Last Name
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="last_name"
                      placeholder="Enter Last Name"
                      type="text"
                      value={last_name}
                      name="last_name"
                      data-cy="last_name"
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg="12">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="username">
                      Username <span className="text-red">*</span>
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="username"
                      placeholder="Enter Username"
                      type="text"
                      value={username}
                      invalid={isEmpty(username) && submitted}
                      name="username"
                      data-cy="username"
                      disabled={update_user_data.id}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg="12">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="email">
                      Email <span className="text-red">*</span>
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="email"
                      placeholder="Enter Email"
                      type="email"
                      value={email}
                      invalid={isEmpty(email) && submitted}
                      name="email"
                      data-cy="email"
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
              </>
            )}
            {formType !== "Edit" && (
              <>
                <Col lg="12">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="password">
                      Password <span className="text-red">*</span>
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="password"
                      placeholder="Enter Password"
                      type="password"
                      value={password}
                      invalid={!update_user_data.id && isEmpty(password) && submitted}
                      name="password"
                      data-cy="password"
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg="12">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="confirm_password">
                      Confirm Password <span className="text-red">*</span>
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="confirm_password"
                      placeholder="Confirm Password"
                      type="password"
                      value={confirm_password}
                      invalid={
                        (!update_user_data.id &&
                          isEmpty(confirm_password) &&
                          submitted) ||
                        checkPassword
                      }
                      name="confirm_password"
                      data-cy="confirm_password"
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
              </>
            )}
            {formType !== "Change Password" && (
              <>
                {userProfile?.is_superuser && (
                  <ToggleCreator
                    testId={"is-superuser"}
                    label={"Superuser?"}
                    checked={is_superuser}
                    onChange={() => handleToggle("is_superuser", !is_superuser)}
                    large
                  />
                )}
                {(userProfile?.is_staff || userProfile?.is_superuser) && (
                  <ToggleCreator
                    testId={"is-staff"}
                    label={"Staff?"}
                    checked={is_staff}
                    onChange={() => handleToggle("is_staff", !is_staff)}
                    large
                  />
                )}
                <ToggleCreator
                  testId={"is-active"}
                  label={"Is Active"}
                  checked={is_active}
                  onChange={() => handleToggle("is_active", !is_active)}
                  large
                />
              </>
            )}
          </Row>
        </div>
      </div>
      <ModalFooter>
        <Button data-cy="submit-btn" onClick={() => onFormSubmit()}>
          SEND
        </Button>
        <Button data-cy="cancel-btn" type={"info-small"} onClick={() => onFormCancel()}>
          CANCEL
        </Button>
      </ModalFooter>
    </>
  );
};

export default AddUserForm;
